import { useSelectedBusiness } from "../../UserAccess/useSelectedBusiness";
import { HttpMethod } from "../../Common/useFetch";
import useUserRequest from "../../Common/useUserRequest";
import { RequestOptions } from "../../Common/useRequest";

export interface EmailConfigurationUpdate {
  isEnabled: boolean;
  sendToCustomers: boolean;
  sendToBranches: boolean;
  sendToDrivers: boolean;
  sendToCarriers: boolean;
  sendToApplicators: boolean;
}

const useUpdateEmailSettings = (options?: RequestOptions) => {
  const business = useSelectedBusiness();

  return useUserRequest<EmailConfigurationUpdate>({
    path: `/api/businesses/${business.id}/emailSettings`,
    method: HttpMethod.PUT,
  }, options);
}

export default useUpdateEmailSettings;